import React, { useEffect, useRef, useState } from 'react';
import { useStore } from '../states/store';
import HLBackendV1Api from '../utils/http/api';
import Winner from '../assets/images/results/winner-container1.png';
import RTRays from '../assets/images/results/sun-rays-orange.png';
import CountUp from 'react-countup';
import { soundLibrary } from '../utils/sfx/sound';
import confetti from 'canvas-confetti';

function WinningBetPanel() {
    const { timerStatus, currentRound, authUser,  currentUpBets, currentDownBets, totalUpBets, totalDownBets, currentUpWager, currentDownWager, resultsData, userBettingResult } = useStore();
    const [isUserWon, setUserWon] = useState(false);
    //const [userBettingResult, setUserBettingResult] = useState(null);

    // const fetchUserResult = async () => {
    //     try {
    //         const response = await HLBackendV1Api.post(
    //             `${process.env.BACKEND_API_URL}/betting-management/get-user-result`,
    //             { _id: currentRound.id, authUser }
    //         );

    //         let { data } = response;
            
    //         // if response.data !== null == winner, else lose
    //         if (Object.hasOwn(data, 'nick')) {
    //             soundLibrary.winner.play();
    //             setUserWon(true);
    //             setUserBettingResult(data);
    //             fireConfetti();
    //         }

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     } finally {
    //         //initConfetti();
    //     }

    // }

    const fireConfetti = () => {
        let scalar = 5;
        let coin = confetti.shapeFromText({ text: '🪙', scalar })
        confetti({
            spread: 360,
            particleCount: 80,
            shapes: [coin],
            scalar: 3,
            ticks: 120

        });
    }

    useEffect(() => {
        // if (timerStatus === 'payout') {
        //     fetchUserResult();
        // }
        // console.log('userBettingResult updated:', userBettingResult);
        if (userBettingResult && Object.hasOwn(userBettingResult, 'user_name')) {
            setUserWon(true);
            soundLibrary.winner.play();
            soundLibrary.haki.play();
            fireConfetti();
        }
    }, [userBettingResult]);



    return <div className="timer-cont animate-timer-payout absolute z-20 p-2 text-white font-bold ">
        { !isUserWon && <span className={"text-3xl font-black text-amber-500 max-sm:text-[1.5rem] mb-2"}>당첨금 지급</span>}
        
        { isUserWon && <div class={"col-span-4 relative mx-auto flex flex-col items-center justify-center animate-slide-in-right-result-summary max-sm:w-[20rem] w-[80%]"}>
            <div class="w-full mt-5 text-center font-bold text-[150%] absolute text-amber-300 z-30 text-shadow-xl text-shadow-black drop-shadow-lg/100">₩ <CountUp end={userBettingResult && userBettingResult.total_bets + userBettingResult.total_pnl}/></div>
            <img class="size-[80%] object-contain rounded-full z-10" src={Winner} alt="Winner" />
            <img class="opacity-60 size-[80%] object-contain absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full animate-[spin_10s_linear_infinite] z-20" src={RTRays} alt="Rays" />
        </div>}

    </div>
}

export default WinningBetPanel;